import { useMemo } from "react";
import { landingPageConfigs } from "../data/landingPageConfigs";
import type { LandingPageWithVariants } from "../types/landingPage";

export function useActiveTrials() {
  const activeTrials = useMemo(() => {
    return Object.values(landingPageConfigs).filter(
      (config: LandingPageWithVariants) => config.status === "active",
    );
  }, []);

  return activeTrials;
}
